import { developerAvatarSrc, type Developer } from "../developer/api";
import { IconCamera, IconHome, IconProfile, IconSdk, IconSettings, IconUsers } from "./icons";

type TabDef = {
  id: string;
  to: string;
  label: string;
  Icon: typeof IconHome;
};

export function mobileTabsFor(me?: Developer | null): TabDef[] {
  const middle: TabDef =
    me?.role === "superadmin"
      ? { id: "users", to: "/users", label: "Users", Icon: IconUsers }
      : { id: "sdk", to: "/sdk", label: "SDK", Icon: IconSdk };
  return [
    { id: "home", to: "/", label: "Home", Icon: IconHome },
    { id: "camera", to: "/cameras", label: "Camera", Icon: IconCamera },
    middle,
    { id: "settings", to: "/settings", label: "Settings", Icon: IconSettings },
    { id: "profile", to: "/profile", label: "Profile", Icon: IconProfile },
  ];
}

/** @deprecated Prefer mobileTabsFor(me) — kept for callers that only need path matching. */
export const MOBILE_TABS = [
  { id: "home", to: "/", label: "Home", Icon: IconHome },
  { id: "camera", to: "/cameras", label: "Camera", Icon: IconCamera },
  { id: "sdk", to: "/sdk", label: "SDK", Icon: IconSdk },
  { id: "settings", to: "/settings", label: "Settings", Icon: IconSettings },
  { id: "profile", to: "/profile", label: "Profile", Icon: IconProfile },
] as const;

export type MobileTabId = string;

export function mobileTabFor(path: string, me?: Developer | null): MobileTabId {
  if (path === "/cameras" || path === "/playback") return "camera";
  if (path === "/live-trip") {
    return new URLSearchParams(window.location.search).get("from") === "cameras" ? "camera" : "home";
  }
  if (path === "/users" || path.startsWith("/users/")) return me?.role === "superadmin" ? "users" : "home";
  if (path === "/sdk" || path === "/developer/web-sdk" || path === "/developer/flutter-sdk" || path === "/developer/sdk") {
    return me?.role === "superadmin" ? "settings" : "sdk";
  }
  if (path === "/profile") return "profile";
  if (
    path.startsWith("/settings") ||
    path === "/dev" ||
    path === "/developer" ||
    path.startsWith("/developer/")
  ) {
    return "settings";
  }
  return "home";
}

export function MobileBottomNav({
  path,
  go,
  me,
}: {
  path: string;
  go: (to: string) => void;
  me?: Developer | null;
}) {
  const tabs = mobileTabsFor(me);
  const active = mobileTabFor(path, me);
  const avatarSrc = me ? developerAvatarSrc(me) : null;
  return (
    <nav className="mobile-bottom-nav" aria-label="Main">
      {tabs.map((tab) => {
        const on = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            className={on ? "is-active" : ""}
            aria-current={on ? "page" : undefined}
            onClick={() => go(tab.to)}
          >
            {tab.id === "profile" && avatarSrc ? <img className="nav-avatar" src={avatarSrc} alt="" /> : <tab.Icon filled={on} />}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
